import "./lazyLoad";
import "./categoryToggle";
import "./filterToggle";
import setupProductFavorites from "./setupProductFavorites";
import setupProductAddToCart from "./setupProductAddToCart";
import "./scrollToTop"; // new import for scroll to top functionality

document.addEventListener("DOMContentLoaded", () => {
  setupProductFavorites();
  setupProductAddToCart();
});

// Listen for lazy-loaded products
document.addEventListener("productsLazyLoaded", () => {
  setupProductFavorites();
  setupProductAddToCart();
});
